export function getComicPageCues(page) {
  const { start, end, id: pageId } = page;
  const pageCue = { pageId, start, end, type: 'page' };
  const boxes = page.boxes;
  const CORRECTED_BUBBLE_ANTICIPATION = 0.75;
  const boxCues = boxes.reduce((acc, box) => {
    const { start, end, id: boxId, type } = box;
    const boxCue = {
      type,
      start,
      end,
      boxId,
      pageId,
    };

    const bubbleCues = box.bubbles
      ? box.bubbles.reduce((acc, bubble) => {
          const {
            start,
            end,
            anticipation,
            id: bubbleId,
            points,
            type,
          } = bubble;
          const bubbleCue = {
            type,
            bubbleId,
            start:
              anticipation && anticipation == CORRECTED_BUBBLE_ANTICIPATION
                ? start
                : start + (anticipation ?? 0) - CORRECTED_BUBBLE_ANTICIPATION,
            end,
            boxId,
            pageId,
          };
          const phraseCue = {
            type: 'phrase',
            start: bubble.phrase.start,
            end: bubble.phrase.end,
            bubbleId,
            boxId,
            pageId,
          };

          return [...acc, bubbleCue, phraseCue];
        }, [])
      : [];
    if (
      bubbleCues &&
      bubbleCues.length &&
      boxCue.start >= bubbleCues[0].start
    ) {
      boxCue.start = bubbleCues[0].start - 0.3;
    }
    return [...acc, boxCue, ...bubbleCues];
  }, []);

  // Put an id on each cue

  const finalCues = [pageCue, ...boxCues].map((cue, index) => ({
    ...cue,
    id: `${pageId}_${index.toString().padStart(5, '0')}`,
  }));
  return finalCues;
}
